import { render, staticRenderFns } from "./BackgroundType.vue?vue&type=template&id=c18b219a"
import script from "./BackgroundType.vue?vue&type=script&lang=js"
export * from "./BackgroundType.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports